// ANCHOR Placeholder
export const PLACEHOLDER = 'No answer';
